import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { Device } from '../../../devices.model_new';
import { ClimatizationDeviceTypesMap, ClimatizationDeviceType, STATE_VAR } from '../../../devices.constant';
import { LayoutModule } from '@angular/cdk/layout';
import { IotService } from '../../../../../core/services/iot.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-thermostat-detail',
  templateUrl: './thermostat-detail.component.html',
  styleUrls: ['./thermostat-detail.component.scss']
})
export class ThermostatDetailComponent implements OnInit, OnDestroy {
@Input()
device: Device;
selectedTemp: string;

realTimeSubscription: Subscription;

  constructor(private iotService: IotService) { }

  ngOnInit() {
    this.iotService.connect();
    if (this.getSetPoint() === null) {
      this.selectedTemp = '7';
    } else {
      this.selectedTemp = this.getSetPoint();
    }
    this.obtainRealTimeResponses();
  }

  getProperties(type: string) {
    return ClimatizationDeviceTypesMap.map.get(ClimatizationDeviceType.THERMOSTAT).properties[type];
  }

  isInStandBy(): boolean {
    if (this.getSetPoint() <= this.getHouseTemperature()) {
      return true;
    } else {
      return false;
    }
  }

  isWarmingUp(): boolean {
    if (this.getSetPoint() > this.getHouseTemperature()) {
      return true;
    } else {
      return false;
    }
  }

  getMinThermoTemp(): number {
    return 7;
  }

  getMaxThermoTemp(): number {
    return 30;
  }

  onTempChange(event) {
    this.iotService.updateModule(this.device, STATE_VAR.SETPOINT, event.value);
  }

  getHouseTemperature() {
    return this.device.getStateVar('processTemp').value;
  }

  getSetPoint(): string {
    const value = this.device.getStateVar('setpoint');
    if (value !== null && value !== undefined) {
      return this.device.getStateVar('setpoint').value;
    } else {
      return '7';
    }
  }

  private obtainCachedResponses(): void {
    this.iotService.responseHistory.forEach((message, moduleLocalId) => {
      this.processMessage(message);
    }
    );
  }

  private obtainRealTimeResponses(): void {
    this.obtainCachedResponses();
    if (this.iotService.messagesObserver) {
      this.realTimeSubscription = this.iotService.messagesObserver.subscribe(
        message => {
          this.processMessage(message);
        }
      );
    }
  }

  private processMessage(message: any): void {
    if (this.device !== undefined) {
      const platformKey = message.platformKey;
      if (platformKey !== STATE_VAR.CONNECTIVITY_STATE) {
        if (platformKey === 'setpoint') {
          this.selectedTemp = message.value;
        }
        const statVar = this.device.getStateVar(platformKey);
        if (statVar) {
          statVar.value = message.value;
        }
      } else {
        this.device.setConnectivityState(message.value);
      }
    }
  }

  ngOnDestroy() {
    if(this.realTimeSubscription) {
      this.realTimeSubscription.unsubscribe();
    }
  }

  setToMin() {
    this.selectedTemp = String(this.getMinThermoTemp());
    this.iotService.updateModule(this.device, STATE_VAR.SETPOINT, this.selectedTemp);
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/devices/device-detail/climatization-detail/thermostat-detail/thermostat-detail.component.ts